<div class="container-fluid p-4 d-flex flex-column gap-4">
  <div class="row">
    <div class="col">
      <app-selected-opportunity [opportunity]="opportunity()" [isLoadingInput]="opportunityLoading()"
        [hasErrorInput]="opportunityError()" />
    </div>
  </div>
  <div class="grid columns-12">
    <div class="g-col-9">
      <app-job-details [job]="opportunity()?.job" [address]="opportunity()?.address" [isLoadingInput]="opportunityLoading()"
        [hasErrorInput]="opportunityError()" (cancelJob)="onJobCancelled()" (addChangeOrder)="onChangeOrderAdded()" />
    </div>
    <div class="g-col-3 h-100">
      <app-payments [job]="opportunity()?.job" [opportunityId]="opportunityId() ?? undefined"
        [isLoadingInput]="opportunityLoading()" [hasErrorInput]="opportunityError()"
        [paymentSummary]="paymentSummary()"
        [pendingCreditRequests]="pendingCreditRequests()"
        [isSendingStatement]="sendingStatement()"
        (postPayment)="onPostPayment()" (editPayment)="onEditPayment($event)"
        (accountCreditRequest)="onAccountCreditRequest()" (reviewAcr)="onReviewAcr()"
        (sendCustomerStatement)="onSendCustomerStatement()"
        (viewCustomerStatement)="onViewCustomerStatement()"
        (viewPaymentHistory)="onViewPaymentHistory()" />
    </div>
  </div>
  @if (showProjectsScroll()) {
  <div class="overflow-x-auto">
    <div class="row d-flex flex-nowrap">
      @for (project of projects(); track project.id; let i = $index) {
      <div class="col-12 col-md-6 col-lg-4">
        <app-project [project]="project" [branchId]="opportunity()?.job?.branchId!" [opportunityId]="opportunityId()!" [job]="opportunity()?.job" [percentProjectPaid]="percentProjectPaid()" [acr]="acr()" [projectPosition]="i + 1" [projectCount]="projectCount()" (permitSaved)="onPermitSaved()" />
      </div>
      }
    </div>
  </div>
  } @else if (projectCount() > 0) {
  <div class="row">
    @for (project of projects(); track project.id; let i = $index) {
    <div
      [class]="projectCount() === 1 ? 'col-12' : projectCount() === 2 ? 'col-12 col-sm-6' : 'col-12 col-md-6 col-lg-4'">
      <app-project [project]="project" [branchId]="opportunity()?.job?.branchId!" [opportunityId]="opportunityId()!" [job]="opportunity()?.job" [percentProjectPaid]="percentProjectPaid()" [acr]="acr()" [projectPosition]="i + 1" [projectCount]="projectCount()" (permitSaved)="onPermitSaved()" />
    </div>
    }
  </div>
  }
  @if (opportunityId()) {
  <div class="row" id="touchpoints" #touchpointsAnchor>
    <div class="col-md-12">
      <groundworks-card>
        <groundworks-card-body>
          <app-touchpoints [opportunityId]="opportunityId()!" />
        </groundworks-card-body>
      </groundworks-card>
    </div>
  </div>
  }
  @if (opportunityId()) {
  <div class="row">
    <div class="col-md-12">
      <app-attachments [opportunityId]="opportunityId()!" />
    </div>
  </div>
  }
</div>
